import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "context/AuthProvider";
import AdminLayout from "pages/AdminLayout";
import LiveScore from "pages/LiveScore";
import Login from "pages/Login";
import Logout from "pages/Logout";

function App() {
  const basename = process.env.REACT_APP_BASENAME || process.env.PUBLIC_URL;

  return (
    <BrowserRouter basename={basename}>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/live_score" element={<LiveScore />} />
          <Route path="/live_score/:idKejuaraan" element={<LiveScore />} />
          <Route path="/live_score/:idKejuaraan/:idKontingen" element={<LiveScore />} />
          <Route path="*" element={<AdminLayout />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
